import { GET_REDIRECTION } from '../../state/queries/User';
import { concatPath } from '../../utils/links/concatPath';
import { dashboardKey, dashboardStackKey, privateKey, regularSessionKey, sessionStackKey } from '../../constants/routeKeys';
import { router } from 'expo-router';
import { useApolloClient } from '@apollo/client';
import { useRef, useState } from 'react';

export const useOnboardingRedirection = () => {
  const client = useApolloClient();
  const [prefetch, setPrefetch] = useState(false);
  const redirectionPrefetchDataRef = useRef(null);

  const fetchRedirection = async (navigateFinally: boolean) => {
    try {
      setPrefetch(true);
      const { data } = await client.query({
        query: GET_REDIRECTION,
        fetchPolicy: 'cache-first',
      });

      if (data && 'getMyProfile' in data && 'registerRedirection' in data['getMyProfile']) {
        const redirection = data['getMyProfile']['registerRedirection'];
        redirectionPrefetchDataRef.current = redirection;

        if(navigateFinally) {
          handleNavigation(redirection);
        }
      }
    } catch (error) {
      console.error('Error fetching redirection:', error);
    }
  };

  const goToDashboard = () => {
    router.navigate({pathname: concatPath([privateKey, dashboardStackKey, dashboardKey], -1) as string});
  };

  // Absolute, like goToDashboard above. This used to be built as
  // concatPath([sessionStackKey, regularSessionKey]) with NO order argument, which
  // defaults to 1 and yields the RELATIVE '../session/regular'. Where that lands
  // depends entirely on the route the app happens to be on when the redirect fires --
  // and it fires right after login / on launch, from the public group or from
  // AuthenticatedApp -- so it frequently resolved to nothing and dropped the user on
  // "Oops, this page does not exist" INSIDE the private app. goToDashboard was already
  // absolute, which is why redirection type NONE always worked and only the
  // RECKONING / ONBOARDING branches broke.
  const regularSessionPath = concatPath([privateKey, sessionStackKey, regularSessionKey], -1) as string;

  const handleNavigation = redirection => {
    if (redirection.type === 'RECKONING') {
      console.log('useRedirect:', 'handle first if');
      router.navigate({
        pathname: regularSessionPath,
        params: {
          sessionId: redirection.session?._id,
          reckoningId: redirection.reckoning?._id,
          fromPath: encodeURIComponent(false),
          fromReckoning: encodeURIComponent(true),
          onboardingDoneWhenThisReckoningIsDone: redirection.reckoning?.onboardingDoneWhenThisReckoningIsDone,
        },
      });
    } else if (redirection.type === 'ONBOARDING') {
      console.log('useRedirect:', 'handle second if');
      router.navigate({
        pathname: regularSessionPath,
        params: {
          sessionId: redirection.session?._id,
          fromPath: encodeURIComponent(false),
          fromReckoning: encodeURIComponent(false),
        },
      });
    } else  {
      goToDashboard();

    }
  };

  const prefetchRedirection = () => {
    console.log('useRedirect:', 'prefetchRedirection', prefetch);
    if(!prefetch) {
      fetchRedirection(false);
    }
  };

  const redirect =  (letGoToOnboarding: boolean) => {
    if(!letGoToOnboarding) {
      goToDashboard();
    } else {
      console.log('useRedirect:', 'redirect main');
      if (redirectionPrefetchDataRef.current) {
        console.log('useRedirect:', 'redirect if');
        handleNavigation(redirectionPrefetchDataRef.current);
      } else {
        console.log('useRedirect:', 'redirect else');
        fetchRedirection(true);
      }
    }
  };

  return { prefetchRedirection, redirect };
};